module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Ramy-Youssef.871a22e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Ramy-Youssef.jpg
// module id = iemf
// module chunks = 0